import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { Action, ActionType } from 'src/app/models/action';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-favorite-button',
  templateUrl: './favorite-button.component.html',
  styleUrls: ['./favorite-button.component.scss', '../base-button.scss'],
})
export class FavoriteButtonComponent extends BaseButtonComponent implements OnChanges, OnInit, OnDestroy {

  @Input()
  recordId: string;
  @Input()
  isMoreOption: string;

  alreadyInFavorites: boolean;

  private favoriteAddedSubscription: Subscription;
  private favoriteRemovedSubscription: Subscription;

  ngOnInit() {
    this.favoriteFacade.favoriteAdded$.subscribe((favoriteAdded) => {
      if (favoriteAdded?.recordId === this.record.id) {
        this.alreadyInFavorites = true;
      }
    });

    this.favoriteFacade.favoriteRemoved$.subscribe((favoriteRemoved) => {
      if (favoriteRemoved?.recordId === this.record.id) {
        this.alreadyInFavorites = false;
      }
    });

    this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(this.record.id) !== undefined;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.record === undefined) {
      this.record = { id: this.recordId };
      this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(this.record.id) !== undefined;
    } else {
      const record = changes.record;
      this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(record.currentValue.id) !== undefined;
    }
  }

  ngOnDestroy(): void {
    this.favoriteAddedSubscription?.unsubscribe();
    this.favoriteRemovedSubscription?.unsubscribe();
  }

  addToFavorites() {
    const action: Action = {
      type: ActionType.ADD_FAVORITE,
      recordId: this.record.id,
    };

    this.doAction(() => {
      this.favoriteFacade.postFavorite(this.record.id).subscribe(() => this.alreadyInFavorites = true);
    }, action);
  }

  removeFromFavorites() {
    const favorite = this.favoriteFacade.getFavoriteByRecordId(this.record.id);

    this.favoriteFacade.deleteFavorite(favorite.recordId).subscribe(() => this.alreadyInFavorites = false);
    ;
  }
}
